import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import Navbar from "react-bootstrap/Navbar"
import Nav from "react-bootstrap/Nav"
import PropTypes from "prop-types"
import "./NavigationBar.scss"
import Container from "react-bootstrap/Container"

const NavigationBar = props => {
  const [scrolled, setScrolled] = useState(false)
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10
      if (isScrolled !== scrolled) {
        setScrolled(!scrolled)
      }
    }
    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [scrolled])

  return (
    <header>
      <Container className="px-0" fluid>
        <Navbar
          fluid="true"
          collapseOnSelect="true"
          expand="lg"
          bg={scrolled ? "light" : "transparent"}
          variant="dark"
          fixed="top"
          className="navbar-toggler navbar-collapse mx-0 customNav mx-auto"
        >
          <Link className="navbar-brand" to="/">
            <img
              className="logo-default companyLogo"
              src={
                scrolled
                  ? require("../images/logo.png")
                  : require("../images/logotwo.png")
              }
              alt="logo"
            ></img>
          </Link>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            className="customNavToggler"
          />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto"></Nav>
            <Nav className="custom-nav">
              <Link
                eventkey={3}
                activeClassName="activeNavItem"
                className={
                  scrolled ? "customDark nav-link" : "customLight nav-link"
                }
                to="/"
              >
                Home
              </Link>
              <Link
                eventkey={1}
                activeClassName="activeNavItem"
                className={
                  scrolled ? "customDark nav-link" : "customLight nav-link"
                }
                to="/Blog"
              >
                Blog
              </Link>
              <Link
                eventkey={2}
                activeClassName="activeNavItem"
                className={
                  scrolled ? "customDark nav-link" : "customLight nav-link"
                }
                to="/About"
              >
                About
              </Link>

              <Link
                eventkey={4}
                activeClassName="activeNavItem"
                className={
                  scrolled ? "customDark nav-link" : "customLight nav-link"
                }
                to="/Contact"
              >
                Contact
              </Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </header>
  )
}
NavigationBar.propTypes = {
  scrolled: PropTypes.bool,
}

NavigationBar.defaultProps = {
  siteTitle: ``,
}
export default React.memo(NavigationBar)
